import ClientCookies from 'js-cookie';
import type { CookieGetOptions, CookieSetOptions } from 'universal-cookie';
import ServerCookies from 'universal-cookie';

const cookies = new ServerCookies();

export const setServerCookie = (
  name: string,
  value: string,
  serverOptions: CookieSetOptions = {}
) => {
  return cookies.set(name, value, {
    path: '/',
    ...serverOptions,
  });
};

export const setClientCookie = (
  name: string,
  value: string,
  clientOptions: Cookies.CookieAttributes = {}
) => {
  return ClientCookies.set(name, value, {
    domain: process.env.NEXT_PUBLIC_APP_DOMAIN,
    path: '/',
    ...clientOptions,
  });
};
export const getServerCookie = (
  name: string,
  serverOptions: CookieGetOptions = {}
) => {
  return cookies.get(name, serverOptions);
};

export const getClientCookie = (name: string) => {
  return ClientCookies.get(name);
};

export const removeServerCookie = (
  name: string,
  serverOptions: CookieSetOptions = {}
) => {
  return cookies.remove(name, {
    path: '/',
    ...serverOptions,
  });
};

export const removeClientCookie = (
  name: string,
  clientOptions: ClientCookies.CookieAttributes = {}
) => {
  return ClientCookies.remove(name, {
    domain: process.env.NEXT_PUBLIC_APP_DOMAIN,
    path: '/',
    ...clientOptions,
  });
};
